import { useState } from 'react'
import axios from 'axios'
import styles from './Contact.module.css'

const API = import.meta.env.VITE_API_GATEWAY_URL

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        phone: '',
        message: ''
    })
    const [status, setStatus] = useState(null) // null | 'sending' | 'success' | 'error'

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setStatus('sending')
        try {
            await axios.post(`${API}/contacto`, {
                ...formData,
                fecha: new Date().toISOString(),
            }, { timeout: 8000 })
            setStatus('success')
            setFormData({ name: '', email: '', company: '', phone: '', message: '' })
            setTimeout(() => setStatus(null), 6000)
        } catch {
            setStatus('error')
            setTimeout(() => setStatus(null), 5000)
        }
    }

    return (
        <div className={styles.contactPage}>
            <div className={styles.hero}>
                <div className={styles.container}>
                    <h1 className={styles.title}>Contáctenos</h1>
                    <p className={styles.subtitle}>
                        Estamos listos para transformar tu empresa con soluciones inteligentes
                    </p>
                </div>
            </div>

            <div className={styles.contentSection}>
                <div className={styles.container}>
                    <div className={styles.grid}>
                        {/* Contact Form */}
                        <div className={styles.formContainer}>
                            <h2 className={styles.sectionTitle}>Envíanos un Mensaje</h2>

                            {status === 'success' && (
                                <div className={styles.successMessage}>
                                    ✓ ¡Mensaje recibido! Te contactaremos a la mayor brevedad.
                                </div>
                            )}
                            {status === 'error' && (
                                <div className={styles.errorMessage}>
                                    ✗ Hubo un problema al enviar. Escríbenos directamente a contacto@ingconia.com - ingconia@outlook.com
                                </div>
                            )}

                            <form onSubmit={handleSubmit} className={styles.form}>
                                <div className={styles.formGroup}>
                                    <label htmlFor="name" className={styles.label}>Nombre Completo *</label>
                                    <input
                                        type="text" id="name" name="name" required
                                        value={formData.name} onChange={handleChange}
                                        className={styles.input} placeholder="Juan Pérez"
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label htmlFor="email" className={styles.label}>Email *</label>
                                    <input
                                        type="email" id="email" name="email" required
                                        value={formData.email} onChange={handleChange}
                                        className={styles.input} placeholder="juan@empresa.com"
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label htmlFor="company" className={styles.label}>Empresa</label>
                                    <input
                                        type="text" id="company" name="company"
                                        value={formData.company} onChange={handleChange}
                                        className={styles.input} placeholder="Nombre de tu empresa"
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label htmlFor="phone" className={styles.label}>Teléfono</label>
                                    <input
                                        type="tel" id="phone" name="phone"
                                        value={formData.phone} onChange={handleChange}
                                        className={styles.input} placeholder="+57 300 123 4567"
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label htmlFor="message" className={styles.label}>Mensaje *</label>
                                    <textarea
                                        id="message" name="message" required
                                        value={formData.message} onChange={handleChange}
                                        className={styles.textarea} rows="5"
                                        placeholder="Cuéntanos cómo podemos ayudarte..."
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className={styles.submitBtn}
                                    disabled={status === 'sending'}
                                >
                                    {status === 'sending' ? '⏳ Enviando...' : 'Enviar Mensaje'}
                                </button>
                            </form>
                        </div>

                        {/* Contact Info */}
                        <div className={styles.infoContainer}>
                            <h2 className={styles.sectionTitle}>Información de Contacto</h2>

                            <div className={styles.contactInfo}>
                                <div className={styles.infoItem}>
                                    <div className={styles.infoIcon}>📧</div>
                                    <div>
                                        <h3 className={styles.infoTitle}>Email</h3>
                                        <p className={styles.infoText}>contacto@ingconia.com - ingconia@outlook.com</p>
                                    </div>
                                </div>

                                <div className={styles.infoItem}>
                                    <div className={styles.infoIcon}>📱</div>
                                    <div>
                                        <h3 className={styles.infoTitle}>Teléfono</h3>
                                        <p className={styles.infoText}>+57 3124432678</p>
                                    </div>
                                </div>

                                <div className={styles.infoItem}>
                                    <div className={styles.infoIcon}>📍</div>
                                    <div>
                                        <h3 className={styles.infoTitle}>Ubicación</h3>
                                        <p className={styles.infoText}>Bogotá, Colombia</p>
                                    </div>
                                </div>

                                <div className={styles.infoItem}>
                                    <div className={styles.infoIcon}>⏰</div>
                                    <div>
                                        <h3 className={styles.infoTitle}>Horario</h3>
                                        <p className={styles.infoText}>Lun - Vie: 8:00 AM - 6:00 PM</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
